wbApp.directive('wbReconciliationDataRangeCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(data) {
            if (!data) { return; }
            return $translate.instant(data.text);
        }

        function formatSelection(data) {
            return $translate.instant(data.text);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 1, text: 'TXT_LBL_FROM_LAST_RECONCILIATION' },
                            { id: 2, text: 'TXT_LBL_FROM_DATE_TO_DATE' }                            
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                }, 1);
            }
        }
    }]);